import { Component, Input } from "@angular/core";

@Component({
    selector: "cerrix-banner",
    templateUrl: "./cerrix-banner.component.html",
    styleUrls: ["./cerrix-banner.component.scss"],
})
export class CerrixBannerComponent {
    @Input() type: "success" | "warning" | "error" | "default" = "default";
    @Input() message: string = "";
}
